<mwc-modal [(mwcVisible)]="visible" (mwcOnCancel)="onCancel()" mwcWidth="544px" [mwcCentered]="true"
  [mwcFooter]="null">
  <ng-container *mwcModalContent>
    <div style="padding-top: 16px;">
      <div mwc-row [mwcGutter]="[16, 16]" style="flex-flow: row;">
        <div mwc-col>
          <div class="mwc-icon-highlight-error-lg">
            <span mwc-icon mwcIconfont="trash-01" style="font-size: 20px;"></span>
          </div>
        </div>
        <div mwc-col>
          <div class="mwc-text-lg-semibold mwc-color-gray-900">Are you sure you want to delete this?</div>
          <p class="mwc-text-sm-regular mwc-color-gray-600 mt-2 mb-0">
            {{ deleteMessageText }}
          </p>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: flex-end; gap: 12px; padding: 16px 0;">
      <button mwc-button mwcType="default" mwcSize="small" (click)="onCancel()">Cancel</button>
      <button mwc-button mwcType="primary" mwcDanger mwcSize="small" (click)="onConfirm()"
        [disabled]="isDisabled">
        <span mwc-icon mwcIconfont="trash-01" style="margin-right: 4px;"></span>{{ confirmButtonLabel }}{{ buttonSuffix }}
      </button>
    </div>
  </ng-container>
</mwc-modal>
